import { gql } from '@apollo/client';

// NOTE: Only exists on api's `fdic` branch.
export const SPECIAL_PII_NOTICE_QUERY = gql`
  query SpecialPiiNotice {
    specialPiiNotice {
      __typename
      version
      text
    }
  }
`;
